import React from 'react'
import Grid from 'gu-ui-kit/Grid/Container'
import Spinner from 'gu-ui-kit/Spinner'
import PropTypes from 'prop-types'

const GridSpinner = ({ width, color, ...rest }) => {
  return (
    <Grid
      {...rest}
      key={'grid-spinner-key'}
      flexAlign={'center'}
      flexDirection={'row'}
      flexJustify={'center'}
    >
      <Grid justifyContent={'center'}>
        <Spinner
          color={color}
          width={width}
        />
      </Grid>
    </Grid>
  )
}

GridSpinner.propTypes = {
  width: PropTypes.number,
  color: PropTypes.string,
}

export default GridSpinner
